import { render, staticRenderFns } from "./deductible.vue?vue&type=template&id=31ef0cf0&scoped=true"
import script from "./deductible.vue?vue&type=script&lang=ts"
export * from "./deductible.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef0cf0",
  null
  
)

export default component.exports